import { GridItem, LayoutGrid, TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';

import PopMembershipTabs from '@/app/[locale]/product/rings/_components/shared/PopMembershipTabs';
import Motion from '@/app/components/Motion';
import SectionHeading from '@/app/components/SectionHeading';

import { popMembershipTabs } from './data/popMembershipTabs';
import { PopMembershipIntro } from './PopMembershipIntro';

export function PopMembership(): JSX.Element {
  const t = useTranslations();

  return (
    <section className="bg-sandstone-300 pb-6 pt-16 lg:pb-20 lg:pt-32">
      <LayoutGrid>
        <GridItem
          colEnd={{ sm: 'main', lg: 17, xl: 16 }}
          colStart={{ sm: 'main' }}
        >
          <div className="md:flex md:justify-center lg:block">
            <div>
              <Motion
                initial={{ opacity: 0 }}
                transition={{ duration: 0.5 }}
                viewport={{ once: true }}
                whileInView={{ opacity: 1 }}
              >
                <TypographyV3
                  className="mb-3 text-sm uppercase tracking-wide"
                  weight="bold"
                >
                  {t('pop_membership_eyebrow')}
                </TypographyV3>
              </Motion>
              <SectionHeading
                animated
                content="pop_membership_title"
                indentation="pl-20 lg:pl-0"
                multiline
                typographyProps={{
                  className:
                    'text-heading-2xl max-w-[330px] mb-4 leading-heading tracking-tighter text-heading-2xl md:max-w-[400px] md:text-[3rem] lg:max-w-none',
                  color: 'inherit',
                  Element: 'h2',
                  variant: 'h3',
                }}
              />
            </div>
          </div>
        </GridItem>
        <GridItem
          className="md:text-center lg:pt-8 lg:text-left"
          colEnd={{ sm: 'main', md: 20, lg: 'main' }}
          colStart={{ sm: 'main', md: 6, lg: 17, xl: 16 }}
        >
          <Motion
            initial={{ opacity: 0 }}
            transition={{ delay: 0.5, duration: 0.5 }}
            viewport={{ once: true }}
            whileInView={{ opacity: 1 }}
          >
            <PopMembershipIntro />
          </Motion>
        </GridItem>
        <GridItem
          className="mt-9 lg:mt-14"
          colEnd={{ sm: 'main' }}
          colStart={{ sm: 'main' }}
        >
          <Motion
            initial={{ opacity: 0 }}
            transition={{ delay: 0.5, duration: 0.5 }}
            viewport={{ once: true }}
            whileInView={{ opacity: 1 }}
          >
            <PopMembershipTabs tabsData={popMembershipTabs} />
          </Motion>
        </GridItem>
      </LayoutGrid>
    </section>
  );
}
